import(/* webpackMode: "eager", webpackExports: ["EntryHeader"] */ "/vercel/path0/app/manifiesto/components/entry-header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ReadingProgress"] */ "/vercel/path0/app/manifiesto/components/reading-progress.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MadeiraAgentContent"] */ "/vercel/path0/app/manifiesto/madeira-agent/components/madeira-agent-content.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MobileTableOfContents"] */ "/vercel/path0/app/manifiesto/madeira-agent/components/mobile-toc.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TableOfContents"] */ "/vercel/path0/app/manifiesto/madeira-agent/components/table-of-contents.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SiteFooter"] */ "/vercel/path0/components/layout/site-footer.tsx");
